import script from "./VTableDebit.vue?vue&type=script&setup=true&lang=js"
export * from "./VTableDebit.vue?vue&type=script&setup=true&lang=js"

import "./VTableDebit.vue?vue&type=style&index=0&id=cd6034ec&scoped=true&lang=less"

import exportComponent from "D:\\develop\\app\\cw\\financial\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd6034ec"]])

export default __exports__